import * as React from 'react';

import { BookingPhotoRequirement } from '../../../_graphql/queryBookingPhotoRequirements';
import { RequirementTag } from '../RequirementTag';

import { GenericFile } from '~/modules/trade/types/file';

type PhotoRequirementTagsProps = {
  photoRequirements: BookingPhotoRequirement[];
  files: GenericFile[];
};

export const PhotoRequirementTags: React.FC<PhotoRequirementTagsProps> = ({
  photoRequirements,
  files,
}) => {
  const uploadedRequirementIds = React.useMemo(
    () =>
      new Set(
        files
          .map((file) => file.metadata?.photoRequirementId)
          .filter((id): id is string => !!id),
      ),
    [files],
  );

  if (photoRequirements.length === 0) {
    return null;
  }

  return (
    <div className="@PhotoRequirementTags mb-4 flex flex-row gap-4">
      {photoRequirements.map((requirement) => (
        <RequirementTag
          key={requirement.id}
          name={requirement.description}
          isRequired={requirement.required}
          isCompleted={uploadedRequirementIds.has(requirement.id)}
        />
      ))}
    </div>
  );
};
